/* eslint-disable react/jsx-props-no-spreading */
import Icon from "../Icon";

const Inkedcustomv6 = (props) => (
  <Icon {...props} name="Inkedcustomv6">
    <path d="M4.267 0h7.467a4.267 4.267 0 0 1 4.267 4.267v7.467a4.267 4.267 0 0 1-4.267 4.267H4.267A4.267 4.267 0 0 1 0 11.734V4.267A4.267 4.267 0 0 1 4.267 0" />
    <path d="M4.44 12.557c-.206-3.063.516-8.191 3.51-8.982 1.617-.447 3.441.241 3.614 2.099.482 4.921-5.369 2.788-7.124 6.883" className="tw-text-white" />
  </Icon>
);

export default Inkedcustomv6;
